import apiConfig from '../../../config/api-config';
import { useVehicleContext } from '../../contexts/vehicle.context'
import { getRecoVehicleQueryArray } from '../../apiService/ApiUtility'
import { useTokenContext } from '../../contexts/token.context'

const cartPagePodIds = ['Cart_1_Compl', 'Cart_2_Bundles']
const cartPageStrategies = ['Complementary', 'Bundles']


export const getRecommendationConfig = (recommendationSetting, ...args) => {
    const [orderDetails, cartData] = args;
    const { strategy, podId, count, enable: isRecommendationEnable } = recommendationSetting;

    if (!podId || !strategy) {
        console.error('podId Or strategy may not configured for page');
        return null;
    }

    const baseURL = `${apiConfig.apiURL}/v2/recommendations/${podId}`;
    const queryParams = [`${count > 6 ? `itemCount=${count}` : ''}`];
    const { selectedVehicle } = useVehicleContext()

    const tokenDB = useTokenContext()

    if (podId === "trackorder_customer_also" && strategy === "Complementary") {
        if (!orderDetails?.items?.length) {
            console.warn('Order items are missing for complementary strategy');
            return null;
        }
        const orderItemIds = orderDetails.items.map(item => `itemId=${item.oid}`);
        queryParams.push(...orderItemIds);
    }

    if (strategy === "BestSellers") {
        if (selectedVehicle) {
            const vehicleFilter = getRecoVehicleQueryArray(selectedVehicle);
            if (vehicleFilter) {
                queryParams.push(...vehicleFilter);
            }
        }
        const userId = tokenDB?.customer_id || tokenDB?.customerId || ''
        queryParams.push(`userId=${~~userId ? userId : ''}`);
    }

    if (cartPagePodIds.includes(podId) && cartPageStrategies.includes(strategy)) {
        if (!cartData?.items?.length) {
            console.warn('Order items are missing');
            return null;
        }

        if (selectedVehicle) {
            const vehicleFilter = getRecoVehicleQueryArray(selectedVehicle);
            if (vehicleFilter) {
                queryParams.push(...vehicleFilter);
            }
        }

        const orderItemIds = cartData.items.map(item => `itemId=${item.product.productId}`);
        queryParams.push(...orderItemIds);
    }

    const recommendationUrl = queryParams.filter(Boolean).length
        ? `${baseURL}?${queryParams.filter(Boolean).join('&')}`
        : baseURL;

    return recommendationUrl;
};
